import React from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';

import FallingCards from './ui/FallingCards';
import Loader from './ui/Loader';

class MetamaskWrapper extends React.Component {

  state = {

    // Simulate a small loading period to avoid a metamask
    // flash when initial page is loading metamask client:
    loading: true,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  }

  render() {

    //TODO: Custom error messages for each:
    if (
      this.props.web3.provider && 
      this.props.web3.feedbagUrl && 
      this.props.web3.ipfsUrl && 
      this.props.web3.ethNetwork
    ) {
      return (
        <div>
          {this.props.children}
        </div>
      );
    }

    if (this.state.loading) {
      return (
        <Grid>
          <Row>
            <Col>
              {this.state.loading &&
                <Loader />
              }
            </Col>
          </Row>
        </Grid>
      );
    }

    if (!this.state.loading) {
      return (
        <FallingCards />
      );
    }

  }
}

const mapStateToProps = (state) => {
  return {
    web3: state.web3,
  };
};

export default connect(mapStateToProps)(MetamaskWrapper);



// WEBPACK FOOTER //
// ./src/components/MetamaskWrapper.js